
import { AlertCircle } from "lucide-react"

interface ValidationErrorProps {
  message: string
}

export function ValidationError({ message }: ValidationErrorProps) {
  return (
    <div className="flex items-center gap-2 mt-1 text-[#ea384c] text-sm">
      <AlertCircle className="h-4 w-4" />
      <span className="whitespace-pre-wrap">{message}</span>
    </div>
  )
}
